import React from 'react';
import './HowPhoneVue.css';
import phonevueWorksImage from '../../assets/images/how-phonevue-works.png';

const HowPhoneVue = () => {
  const steps = [
    {
      number: '01',
      title: 'Download PhoneVue',
      description: 'Download the PhoneVue app for free. Once installed, you can start using diagnostic tests immediately.'
    },
    {
      number: '02',
      title: 'Run Diagnostic Tests',
      description: 'Run diagnostic tests on your smartphone to check hardware and system functionality.'
    },
    {
      number: '03',
      title: 'Battery Deterioration Test',
      description: 'Run the world\'s first battery deterioration test on your Android smartphone and view results instantly in the Report section.'
    },
    {
      number: '04',
      title: 'Review Diagnostic Results',
      description: 'Check your complete diagnostic results and understand your smartphone\'s condition in real time.'
    },
    {
      number: '05',
      title: 'Save Your Test History',
      description: 'Register with a simple login to securely record and manage all your smartphone diagnostic test results.'
    }
  ];

  return (
    <div className="how-phonevue-page">
        <div className="how-phonevue-container">
          <div className="how-phonevue-header">
            <p className="section-label">Quick Setup</p>
            <h1 className="section-title">How PhoneVue Works?</h1>
            <p className="section-intro">
              PhoneVue makes smartphone diagnostics simple and accessible. Follow a few guided steps to test your device, review results, and keep track of your phone's health.
            </p>
          </div>

          <div className="how-phonevue-content">
            <div className="phone-and-steps-wrapper">
              <div className="phone-illustration-container">
                <img src={phonevueWorksImage} alt="PhoneVue Works" className="phone-screen-image" />
              </div>
              <div className="steps-container">
                {steps.map((step, index) => (
                  <div key={index} className="step-item">
                    <div className="step-number">{step.number}</div>
                    <div className="step-content">
                      <h3 className="step-title">{step.title}</h3>
                      <p className="step-description">{step.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
    </div>
  );
};

export default HowPhoneVue;
